export default "__VITE_ASSET__DMdlmqej__"